import type { CSSProperties } from 'react';

/** Режим отображения реестра: встроенный блок (legacy) или внутри Drawer. */
export type WorkspaceRegistryVariant = 'embedded' | 'drawer';

const EMBEDDED_LIST_CARD_HEIGHT = 520;
const EMBEDDED_TABLE_SCROLL_HEIGHT = 340;

export type WorkspaceRegistryListLayout = {
  hideCardChrome: boolean;
  cardStyle: CSSProperties;
  cardBodyStyle: CSSProperties;
  scrollAreaStyle: CSSProperties;
};

/**
 * Единый layout-reolver для WorkspaceMyRoutes / WorkspaceMyApplications.
 * embedded — прежняя фиксированная высота (520px / scroll 340px).
 * drawer  — flex-fill доступного пространства Drawer.
 */
export function resolveWorkspaceRegistryListLayout(
  variant: WorkspaceRegistryVariant = 'embedded'
): WorkspaceRegistryListLayout {
  if (variant === 'drawer') {
    return {
      hideCardChrome: true,
      cardStyle: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        border: 'none',
        boxShadow: 'none',
      },
      cardBodyStyle: {
        padding: 0,
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      },
      scrollAreaStyle: {
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        scrollbarGutter: 'stable',
      },
    };
  }

  return {
    hideCardChrome: false,
    cardStyle: {
      height: EMBEDDED_LIST_CARD_HEIGHT,
      display: 'flex',
      flexDirection: 'column',
    },
    cardBodyStyle: {
      padding: 12,
      flex: 1,
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    scrollAreaStyle: {
      flex: '0 0 auto',
      height: EMBEDDED_TABLE_SCROLL_HEIGHT,
      minHeight: 0,
      maxHeight: EMBEDDED_TABLE_SCROLL_HEIGHT,
      overflowY: 'auto',
      overflowX: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      scrollbarGutter: 'stable',
    },
  };
}
